import { SVGProps } from 'react'

const EarnNavIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.634 15.204V.66h.744v14.545h-.744Zm3.198-10.181c-.064-.648-.35-1.163-.858-1.546-.507-.382-1.145-.574-1.914-.574-.542 0-1.02.093-1.432.279-.41.185-.731.443-.966.773a1.877 1.877 0 0 0-.347 1.113c0 .307.067.576.2.807.132.231.31.43.533.597.228.162.478.303.75.42.277.117.555.216.836.295l1.227.353c.371.102.742.233 1.113.392.372.159.71.36 1.018.602.31.239.558.532.744.88.19.345.284.76.284 1.245 0 .621-.161 1.18-.483 1.676-.322.496-.784.89-1.386 1.182-.603.288-1.324.432-2.165.432-.792 0-1.48-.13-2.063-.392-.583-.265-1.041-.63-1.375-1.097a3.083 3.083 0 0 1-.562-1.62h1.09c.039.46.19.848.455 1.166.265.318.61.56 1.034.727.425.163.898.244 1.42.244.58 0 1.096-.096 1.546-.29.455-.196.81-.47 1.069-.818.26-.352.392-.761.392-1.227 0-.394-.103-.723-.307-.989-.205-.269-.49-.494-.858-.676a7.583 7.583 0 0 0-1.267-.483l-1.392-.409c-.913-.273-1.622-.65-2.125-1.13-.504-.482-.756-1.095-.756-1.841 0-.625.167-1.175.5-1.648a3.36 3.36 0 0 1 1.364-1.114c.575-.269 1.221-.403 1.937-.403.724 0 1.364.132 1.92.398.557.265.999.63 1.324 1.096.33.462.506.989.529 1.58h-1.029Z"
    />
  </svg>
)
export default EarnNavIcon
